export default __webpack_public_path__ + "static/media/RTR200FI_Frente.926a6793.webp";